import { useState } from 'react';
import { ConfigProvider, Form } from 'antd';
import { Input, Button } from "mobily-ui-library/lib";
import { useTranslation } from 'react-i18next';

import { getPaymentDividend } from '../../api/api';
import { Error } from '../Util/Util';
import './InputType.scss';

type InputProps = {
    dir: string;
    rtl: boolean;
    radioValue: string;
    setLoading: (value: boolean) => void;
    setShowResult: (value: boolean) => void;
    setTableData: (value: any) => void;
}

function InputType({ dir, rtl, radioValue, setLoading, setShowResult, setTableData }: InputProps) {
    const [nationalId, setNationalId] = useState('');
    const [coporateId, setCoporateId] = useState('');
    const { t } = useTranslation();

    const direction: any = dir;
    const [form] = Form.useForm();

    const submitForm = () => {
        if (coporateId !== '' || nationalId !== '') {
            setLoading(true);
            getPaymentDividend(nationalId)
                .then((res: any) => {
                    if (res.data.status.code === "MAPI-000") {
                        setTableData(res.data.data);
                        setTimeout(() => {
                            setLoading(false);
                            setShowResult(true);
                            setNationalId('');
                            setCoporateId('');
                            form.resetFields();
                        }, 2000)
                    } else {
                        const msg = rtl ? res.data.status.arabicDetail : res.data.status.englishDetail
                        Error(msg)
                        setLoading(false);
                        setShowResult(false);
                        setNationalId('');
                        setCoporateId('');
                        form.resetFields();
                    }
                }).catch((err) => {
                    Error(t("Unexpected_error"))
                    setLoading(false);
                    setShowResult(false);
                    setNationalId('');
                    setCoporateId('');
                    form.resetFields();
                })
        }
    }

    return (
        <div className='form-registration'>
            <ConfigProvider direction={direction}>
                <Form form={form} name="control-ref" onFinish={submitForm}>
                    {radioValue === 'individuals' ? (
                        <Form.Item
                            initialValue={nationalId}
                            hasFeedback
                            name='nationalId'
                            rules={[{ required: true, message: t('National_IdValidation') }]}
                        >
                            <Input
                                rtl={rtl}
                                placeholder={'XX XX XX XX XX'}
                                headingleft={t('ID_number')}
                                headingright={t('National_Id')}
                                className='nationalId-input'
                                width={'410px'}
                                onChange={(e: any) => setNationalId(e.target.value)}
                            />
                        </Form.Item>
                    ) : (
                        <Form.Item
                            initialValue={coporateId}
                            hasFeedback
                            name='corporate'
                            rules={[{ required: true, message: t('CRN_Validation') }]}
                        >
                            <Input
                                rtl={rtl}
                                placeholder={`${t('Enter')} ${t('CR_Number')}`}
                                headingleft={t('CR_Number')}
                                className='corporate-input'
                                width={'410px'}
                                onChange={(e: any) => setCoporateId(e.target.value)}
                            />
                        </Form.Item>
                    )}
                    <Form.Item>
                        <div className='submitButton'>
                            <Button
                                primary={true}
                                rtl={rtl}
                                htmlType={'submit'}
                            >
                                {t('Submit')}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </ConfigProvider>
        </div>
    )
}

export default InputType